import { render, staticRenderFns } from "./BlogCategoryTagDetail.vue?vue&type=template&id=f6ed87b4&scoped=true&"
import script from "./BlogCategoryTagDetail.vue?vue&type=script&lang=js&"
export * from "./BlogCategoryTagDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlogCategoryTagDetail.vue?vue&type=style&index=0&id=f6ed87b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ed87b4",
  null
  
)

export default component.exports